import styled from "styled-components";
import OrcHeroImg from "./img/ork_hero.gif"
import { TipMouseOutEvent, TipMouseOverEvent } from "../../../Tooltip/Tooltip";
import { WavSoundEffect } from "../../../WavSoundEffects/WavSoundEffects";

function RegulamentDescript(){
    return(
        <ColumnMaster>
            
        <Fieldset id="novocadastro">
             <Legend>
                <OrcHerGif bgImg={OrcHeroImg}
                onMouseOver={(event) => {
                    TipMouseOverEvent(event, "... ♪ <br> (não clique!)", "rgb(0,0,0,1)");
                     WavSoundEffect('/wav/ork_warrior_breath.wav', ' ', 'hover')}}
                onMouseLeave={() => TipMouseOutEvent() } 
                onClick={() => WavSoundEffect(' ', '/bgm/35.mp3', 'click')} />
                <h1>Termos de Utilização</h1>
             </Legend>
        <Span>

        Estas regras foram criadas para garantir um ambiente de jogo justo e seguro para todos os jogadores. O não cumprimento das normas listadas abaixo poderá resultar em penalidades, incluindo o banimento permanente da conta.<br/><br/>

        1. Adequação e Conteúdo<br/>
        1.1. Restrição de Idade: O servidor é destinado exclusivamente a jogadores maiores de 18 anos. Ao criar uma conta, o usuário declara ter a idade mínima exigida.<br/><br/>

        1.2. Tolerância Zero: É proibida a divulgação de qualquer tipo de material ilegal ou conteúdo que incite ódio, violência ou discriminação, bem como a divulgação de material pornográfico. Tais condutas não serão toleradas e acarretarão em banimento permanente de todas as contas do usuário, sem qualquer tipo de ressarcimento ou devolução de itens.<br/><br/>

        2. Segurança e Responsabilidade da Conta<br/>
        2.1. Responsabilidade do Jogador: A segurança de seus dados de acesso (login, senha, e-mail e PIN) é de sua exclusiva responsabilidade. Mantenha essas informações em sigilo e segurança.<br/><br/>

        2.2. Compartilhamento de Conta: Ao compartilhar sua conta com terceiros, você se torna responsável por todas as ações realizadas nela. Quaisquer penalidades serão aplicadas à conta, independentemente de quem a estava utilizando.<br/><br/>

        2.3. Perdas por Compartilhamento: A equipe LionsRag não se responsabiliza e não poderá ajudar na recuperação de itens ou personagens deletados em casos de roubo de conta, pois o acesso foi permitido pelo próprio proprietário. Nesses casos, a distinção entre uso legítimo e indevido é impossível.

        2.4. Prevenção de Segurança: Aconselhamos a todos os jogadores a manterem seus softwares de segurança (antivírus/anti-spyware) atualizados. A equipe LionsRag não se responsabiliza por roubo de contas através de softwares maliciosos como Keyloggers ou por acessos realizados em locais inseguros.<br/><br/>

        2.5. Solicitação de Dados: A staff do LionsRag jamais solicitará sua senha, e-mail, PIN ou outras informações de acesso, seja dentro ou fora do jogo. Desconfie de qualquer pessoa que solicite esses dados.<br/><br/>

        3. Conduta e Proibições<br/>
        3.1. Comercialização: É estritamente proibida a comercialização de contas, personagens ou itens por dinheiro real. Contas e personagens envolvidos em qualquer tipo de negociação (incluindo anúncios) serão banidos permanentemente.<br/><br/>

        3.2. Softwares Maliciosos: O uso de qualquer software malicioso (bots, trainers, hacks, etc.) que ofereça vantagem indevida ou prejudique outros jogadores será punido com o banimento permanente da conta, independentemente do status VIP.<br/><br/>

        3.3. Divulgação: A divulgação de outros servidores dentro do jogo resultará em banimento permanente da conta e do e-mail de registro do infrator.<br/><br/>

        4. Informações e Benefícios VIP<br/>
        4.1. Duração do Acesso VIP: O período ativo do benefício VIP começa a ser contado a partir do momento em que a doação é confirmada pela provedora de pagamento.<br/><br/>

        4.2. Devolução de Itens: Em caso de acesso indevido à sua conta, não haverá devolução de itens. No entanto, o caso será investigado para identificar possíveis infrações cometidas.<br/><br/>

        Atenciosamente,
        LionsRag - Ragnarok Online Private Server
            </Span>

	        </Fieldset>
        </ColumnMaster>

    );
}

export default RegulamentDescript;

const ColumnMaster = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 700px;
    margin-top: 0px;

    //border: solid 2px black;
    //box-shadow: 0px 0px 5px 0px black;
    padding: 0px;

    @media (max-width: 1000px) {
    width: 90vw;
    }
    
`

const Fieldset = styled.fieldset`
    margin: 0px 0;
    width: 100%;
	
    padding: 0px 50px;
    border: solid 2px rgba(0,0,0,1);
    box-shadow: 5px 5px 10px 0px black;
    border-radius: 10px;
    background-color: rgba(70, 98, 169, 1);
    color: white;

    @media (max-width: 1000px) {
    width: 90vw;
    }
`

const Span = styled.div`
    text-align: justify;
    letter-spacing: .5px;
    padding: 0px 10px;
    margin-bottom: 20px;
    overflow-y:scroll;
    height: 500px;
    font-size: 12pt;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }
`

const Legend = styled.legend`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
`

const OrcHerGif = styled.div`
    background-image: url(${props => props.bgImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 80px;
    height: 180px;
    //border: solid 2px black;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }
`